import { makeGetCall } from "./mainHook";

const getFileByFilename = (filename, successHandler, errorHandler) => {
  makeGetCall(`file/${filename}`, successHandler, errorHandler);
}

export {
  getFileByFilename,
}